import React, { useCallback, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { BiData, BiContextProvidedValue, } from '@wix/da-bi/pkg/events';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';
import CommentOutline from '@wix/da-ds/pkg/Icons/24x24/CommentOutline';
import { getDeviationResourceType } from '../../../DeviationViews/_helpers';
import ActionBarToggleButton from '../../_partials/items/ActionBarToggleButton';
import ActionBarButtonRestricted from '../../_partials/ActionBarButtonRestricted';
var CommentButton = function (_a) {
    var _b, _c;
    var deviation = _a.deviation, extended = _a.deviation.extended, onToggleCommentPanel = _a.onToggleCommentPanel, isCommentPanelOpen = _a.isCommentPanelOpen, isOwner = _a.isOwner, actionBarType = _a.actionBarType;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var addCommentLabel = useFlag('addacomment');
    var onClick = useCallback(function () {
        if (!extended) {
            return;
        }
        onToggleCommentPanel(deviation, actionBarType);
    }, [extended, onToggleCommentPanel, deviation, actionBarType]);
    return (React.createElement(ActionBarButtonRestricted, { subscribersOnly: true, deviation: deviation, tooltip: isOwner ? t('actionbar.comment') : undefined, button: React.createElement(ActionBarToggleButton, { activated: isCommentPanelOpen, onClick: onClick, "data-hook": BiDataHook.DEVIATION_COMMENT_BUTTON, icon: CommentOutline, label: isOwner || isMobile
                ? undefined
                : addCommentLabel
                    ? t('actionbar.comment.label')
                    : t('actionbar.comment'), biData: BiData({
                evid: 105,
                typeid: getDeviationResourceType(deviation),
                itemid: deviation.deviationId,
                creatorid: (_c = (_b = deviation.author) === null || _b === void 0 ? void 0 : _b.useridUuid) !== null && _c !== void 0 ? _c : '',
                sectionname: BiContextProvidedValue,
                sectionid: BiContextProvidedValue,
                section_typeid: BiContextProvidedValue,
                sectiontype: BiContextProvidedValue,
                sectionrank: BiContextProvidedValue,
                rank: BiContextProvidedValue,
                sort_type: BiContextProvidedValue,
                reason_shown: BiContextProvidedValue,
                widgetname: BiContextProvidedValue,
            }) }) }));
};
CommentButton.displayName = 'CommentButton';
export default CommentButton;
//# sourceMappingURL=CommentButton.js.map